export default ['JsonRPCService', 'JobService', (JsonRPCService, JobService) => {
    return {
        findJobByJobNumber: (policyChangeNumber) => {
            return JsonRPCService.send('pc', 'gateway/policychange', 'findJobByJobNumber', [policyChangeNumber]);
        },
        getPolicyChangeSummary: (policyChangeNumber) => {
            return JsonRPCService.send('pc', 'gateway/policychange', 'getPolicyChangeSummary', [policyChangeNumber]);
        },
        getNotesForPolicyChange: (policyChangeNumber) => {
            return JsonRPCService.send('pc', 'gateway/policychange', 'getNotesForPolicyChange', [policyChangeNumber]);
        },
        createNoteForPolicyChange: (policyChangeNumber, noteDTO) => {
            return JsonRPCService.send('pc', 'gateway/policychange', 'createNoteForPolicyChange', [policyChangeNumber, noteDTO]);
        },
        getDocumentsForPolicyChange: (policyChangeNumber) => {
            return JsonRPCService.send('pc', 'gateway/policychange', 'getDocumentsForPolicyChange', [policyChangeNumber]);
        },
        getUWIssuesForPolicyChange: (policyChangeNumber) => {
            return JsonRPCService.send('pc', 'gateway/policychange', 'getUWIssuesForPolicyChange', [policyChangeNumber]);
        },
        referToUnderwriter: (policyChangeNumber, noteBody) => {
            return JsonRPCService.send('pc', 'gateway/policychange', 'referToUnderwriter', [policyChangeNumber, noteBody]);
        },
        withdrawPolicyChangeByPolicyChangeNumber: (policyChangeNumber) => {
            return JobService.withdrawJobByJobNumber(policyChangeNumber);
        }
    };
}];